import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import Grid from '@material-ui/core/Grid'
import Typography from '@material-ui/core/Typography'
import { Box } from '@material-ui/core'
import WidgetFooterButton from './WidgetFooterButton'
import Widget from '../Widget'
import Loading from '../helpers/Loading'
import WhatsNewList from './components/WhatsNewList'

import {
  selectWhatsNewData,
  fetchWhatsNewArticles,
} from '../../../apps/Pages/WhatsNewPage/WhatsNewPageSlice'
import styles from './WhatsNewStyles'
import { logDashboardEvent } from '../../events'
import { ErrorMessage } from '../../DashboardComponents/ErrorMessages/ErrorMsg'

function WhatsNew({
  className,
  title,
  widgetId,
  showNote,
  noteMessage,
  notePosition,
  noteBackground,
  noteIcon,
  noteUrl,
  noteFontColor,
}) {
  const dispatch = useDispatch()
  const widgetData = useSelector(selectWhatsNewData)
  const widgetStatus = 'fulfilled'
  const classes = styles()

  React.useEffect(() => {
    dispatch(fetchWhatsNewArticles())
  }, [])

  return (
    <Widget className={className}>
      <Widget.Header title={title} category="default" />
      <Widget.Content
        className={classes.container}
        showNote={showNote}
        noteMessage={noteMessage}
        notePosition={notePosition}
        noteBackground={noteBackground}
        noteIcon={noteIcon}
        noteUrl={noteUrl}
        noteFontColor={noteFontColor}
      >
        {renderWidget(
          widgetStatus,
          widgetData,
          classes,
          widgetId,
          title,
          dispatch,
        )}
      </Widget.Content>
    </Widget>
  )
}

function renderWidget(
  widgetStatus,
  widgetData,
  classes,
  widgetId,
  title,
  dispatch,
) {
  switch (widgetStatus) {
    case 'pending':
      return <Loading />
    case 'error':
      return <ErrorMessage />
    case 'fulfilled':
      return (
        <Loaded
          widgetData={widgetData}
          classes={classes}
          widgetId={widgetId}
          title={title}
          dispatch={dispatch}
        />
      )
    default:
      return <ErrorMessage />
  }
}

function Loaded({ widgetData, classes, widgetId, title, dispatch }) {
  // console.log(
  //   'Widget loaded: ',
  //   widgetData,
  //   'ID',
  //   widgetId,
  //   'dahfunction',
  //   logDashboardEvent,
  // )
  const articles = widgetData.articles?.articles ?? []
  const numOfArticles = widgetData.articles?.articles?.length ?? 0
  const handleClick = () => {
    const isLocalhost = window.location.hostname === 'localhost'
    const path = isLocalhost ? '/WhatsNew/' : '/uxp/WhatsNew/'
    if (widgetId && dispatch) {
      logDashboardEvent(
        dispatch,
        'dashboardEvent',
        widgetId,
        'Whats New',
        '/WhatsNewArticle/',
      )
    }
    window.open(path, '_blank')
  }

  return (
    <Grid container direction="column">
      <Grid item className={classes.articleCountContainer}>
        <Typography variant="body2" className={classes.numOfArticles}>
          {numOfArticles} articles
        </Typography>
      </Grid>
      <Grid item>
        <WhatsNewList articles={articles} numOfArticles={numOfArticles} />
      </Grid>
      <Grid item>
        <Box className={classes.footer}>
          <WidgetFooterButton
            title={`${title} Homepage`}
            handleClick={handleClick}
          />
        </Box>
      </Grid>
    </Grid>
  )
}

export default WhatsNew
